<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
      <template #button-content>
        <div class="d-md-flex d-none user-nav">
          <p class="user-name mb-0 text-uppercase">
            {{ user && user.name }}
          </p>
          <!-- <span class="user-status">{{ userData.role }}</span> -->
        </div>

          <img v-if="user && user.avatar" :src="user && user.avatar" class="avatar-image rounded-circle" data-test="avatar-image" width="40px" height="40px" style="object-fit: cover;"/>
          <div v-else >
              <b-avatar
                  class="d-block mx-auto"
                  size="40"
                  :text="avatarInitialis()"
                  :variant="`light-primary`"
                  data-test="avatar-initial"
              />
          </div>

        <!-- <b-avatar v-if="user.avatar" size="40" :src="user.avatar" :variant="`light-primary`"/>
        <b-avatar v-else size="40" :text="avatarInitialis()" :variant="`light-primary`" /> -->
      </template>

      <b-dropdown-item link-class="d-flex align-items-center  pb-.5" @click="profile">
        <feather-icon size="16" icon="UserIcon" class="mr-50" />
        <span>Profile</span>
      </b-dropdown-item>

      <b-dropdown-item v-if="user && user.is_secretary_admin" link-class="d-flex align-items-center  pb-.5" @click="viewAs">
        <vector
            data-type="icon"
            data-width="16px"
            data-height="16px"
            data-name="user-switch"
            data-class="mr-50"
        />
        <span>{{ viewAsLabel }}</span>
      </b-dropdown-item>

      <b-dropdown-divider />
      

      <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
        <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
        <span>Logout</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
        BNavItemDropdown,
        BDropdownItem,
        BDropdownDivider,
        BAvatar,
    },
    data() {
        return {
            isDropdown2Visible: false,
            isDropdown1Visible: false,
            // userData: JSON.parse(localStorage.getItem('userData')),
            userData: {
                fullName: 'John Doe',
            },
            avatarText,
        };
    },

    computed: {
        ...mapGetters({
            user: 'auth/user',
            actAs: 'auth/actAs'
        }),

        viewAsLabel() {
            if(this.actAs === "user")
                return "Switch to Administrator";
            return "Switch to User";
        },
    },

    created() {
        this.$store.commit('auth/SET_ACT_AS', window.localStorage.getItem('actAs'));
    },

    methods: {
        ...mapActions({
            logoutAction: 'auth/logout',
        }),

        async logout() {
            document.getElementById('app').style.display = 'none';
            document.getElementById('loading-bg').style.display = 'block';

            this.$store.commit('cart/CLEAR');
            this.$store.commit('company/CLEAR');
            this.$store.commit('auth/CLEAR_USER_DATA');
            this.$store.commit('auth/SET_AUTHENTICATED', false);
            this.$store.commit('auth/UPDATE_ONBOARDING_STATUS', false);
            this.$store.commit('company/SET_REGISTRATION_TYPE', null);
            this.$store.commit('document/CLEAR');

            await this.logoutAction();

            this.$cache.clearAll();
            // this.$router.push({ name: 'login' });
            this.$nextTick(() => {
                window.location.reload();
                // document.getElementById('app').style.display = 'block';
                // document.getElementById('loading-bg').style.display = 'none';
            });

        },

        profile() {
            this.$router.push({ name: 'profile' });
        },

        avatarInitialis() {
            if (this.user) {
                const nameArray = this.user.name.split(' ');
                return `${nameArray[0][0]}${nameArray[nameArray.length - 1][0]}`;
            }
            return '';
        },

        viewAs() {
            this.$router.push({ query: { as: this.actAs }});

            if(this.actAs === 'user') {
                window.localStorage.actAs = "admin";
                this.$store.commit('auth/SET_ACT_AS', 'admin');
            }
            else {
                window.localStorage.actAs = "user";
                this.$store.commit('auth/SET_ACT_AS', 'user');
            }
        }

    // randomAvatarVariant()
    // {
    //     const variants = ['primary', 'secondary', 'info', 'warning', 'danger', 'success', 'light', 'dark'];
    //     return variants[Math.floor(Math.random() * variants.length)];
    // }
    },
};
</script>

<style scoped>
/* #dropdown-2 {
  padding: 7px 0px;
  position: relative;
  right: 8px;
}

.right-content {
  position: absolute;
  top: -35px;
  background:#fff;
  box-shadow: 0 5px 25px rgba(34, 41, 47, 0.1);
  padding: 5px 0px;
} */
</style>
